import request from '@/utils/request'
import BaseUrl from '@/config/index'

// 身份认证模块接口
export default {
  // 获取拉取小程序url
  miniprogSchemeUrl: (data, pathData) => {
    return request({
      data,
      url: `/miniprogram/wechat/get_miniprog_scheme_url`,
      method: 'GET'
      // takePeeridAndSessionid: true
    })
  },
  // 获取短信验证码
  SMSVerificationCode: (data, pathData) => {
    return request({
      data,
      url: `/basic/protect_msgcode`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 获取图形验证码
  graphicalCode: (data, pathData) => {
    return request({
      data,
      url: `/login_checkcode_image/${pathData.peerid}`,
      method: 'GET',
      responseType: 'blob'
    })
  },
  // 获取图形验证码2 http://112.74.210.163:16830/basic/peerid?imei=&clienttype=web&_=1780906548263
  graphicalCode2: (data) => {
    return request({
      data,
      url: `/basic/peerid`,
      method: 'GET'
      // responseType: 'blob'
    })
  },
  // 注册
  register: (data) => {
    return request({
      data,
      url: `/user/web_register`,
      method: 'POST',
      takePeeridAndSessionid: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 用户详细信息
  userInfoDetail: (data) => {
    return request({
      data,
      url: `/user/info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 获取配置信息
  authIdeCconfigInfo: (data) => {
    return request({
      data,
      url: `/basic/get_auth_iden_config_info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 提交身份认证信息
  submitAuthIdenInfo: (data) => {
    return request({
      data,
      url: `/user/auth/commit_auth_iden_info`,
      method: 'GET',
      takePeeridAndSessionid: true
    })
  },
  // 下载图片
  downLoadPic: (pathData) => {
    return request({
      // data,
      url:
        BaseUrl.downloadUrl +
        `/common/${pathData.peerid}/${pathData.sessionid}/${pathData.resourceid}`,
      method: 'GET',
      responseType: 'blob'
    })
  },
  // 获取项目进展与分成信息
  projectStageInfo: (data) => {
    return request({
      data,
      url: `/project/stage/get_project_stage_info`,
      method: 'GET'
      // takePeeridAndSessionid: true
    })
  },
  // 提交报名申请
  applyEnroll: (data) => {
    return request({
      data,
      url: `/index/apply_enroll`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
      // takePeeridAndSessionid: true
    })
  },
  // 加入并购库-获取创建项目提示信息列表
  projecTips: (data) => {
    return request({
      data,
      url: `/platform/info/get_platform_info_project_tips_config`,
      method: 'GET'
    })
  },
  // 加入并购库-信息录入-获取信息类型
  platformInfoType: (data) => {
    return request({
      data,
      url: `/platform/info/get_platform_info_type`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 加入并购库-信息录入-获取财务数据配置
  financConfig: (data) => {
    return request({
      data,
      url: `/platform/info/get_platform_info_project_finance_config`,
      method: 'GET'
    })
  },
  // 加入并购库-信息录入-保存
  createInfoProject: (data) => {
    return request({
      data,
      url: `/platform/info/create_info_project`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 查询公司列表-仅H5页面使用
  searchCompany: (data) => {
    return request({
      data,
      url: `/project/company_list_search`,
      method: 'get'
    })
  }
}
